export const getTestIdFromString = (value: string) =>
  value.toLowerCase().trim().split(' ').join('-');
